import { render } from "./task-reports.vue?vue&type=template&id=585dc47b"
import script from "./task-reports.vue?vue&type=script&lang=js"
export * from "./task-reports.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__